import globalStore, { Flag } from "@/models/GlobalStore";

export default class CarCostType {
    id = 1;
    name = '';
    newCar = false;
    shcCar = false;
    isStockValue = false;
}

export const getFlags = (item: CarCostType): Flag[] => {
    const flags = [];
    if (item.newCar) {
        flags.push(globalStore.flags.IsNewPostCalcType);
    }
    if (item.shcCar) {
        flags.push(globalStore.flags.IsShcPostCalcType);
    }
    if (item.isStockValue) {
        flags.push(globalStore.flags.IsStockPostCalcType);
    }
    return flags;
}